import * as React from 'react';
import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavBlog = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M14 4v16h8V4h-8Zm6 14h-4V6h4v12ZM2 12h10V4H2v8Zm2-6h6v4H4V6ZM12 14H2v2h10v-2ZM12 18H2v2h10v-2Z"
    />
  </svg>
);
export default SvgNavBlog;
